import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconBuilding = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 228 385">
    <rect fill={theme.palette.primary.A100} height="267" width="88" y="118" x="71" />
    <g fill={theme.palette.grey[100]}>
      <rect y="138" width="14" x="64" height="28" />
      <rect y="138" width="14" x="152" height="28" />
      <path d="m55 166h120v219h-120v-219zm30 0v131h58v-131h-58z" />
    </g>
    <rect fill={theme.palette.primary.A100} height="2" width="14" y="164" x="64" />
    <rect fill={theme.palette.primary.A100} height="2" width="14" y="164" x="152" />
    <polygon fill={theme.palette.primary.A400} points="85 297 85 166 104.95 166 104.95 277 143 277 143 297 104.95 297" />
    <g fill={theme.palette.primary.A400}>
      <rect y="138" width="14" x="78" height="28" />
      <rect transform="matrix(0,1,-1,0,250.5,67.5)" height="27" width="14" y="145.5" x="84.5" />
      <rect y="325" width="20" x="80" height="60" />
      <rect transform="matrix(0,1,-1,0,489,261)" height="68" width="20" y="341" x="104" />
    </g>
    <rect fill={theme.palette.grey[100]} height="60" width="60" y="325" x="20" />
    <rect fill={theme.palette.primary.A100} height="30" width="20" y="355" x="0" />
    <rect fill={theme.palette.primary.A100} height="30" width="20" y="355" x="208" />
    <rect fill={theme.palette.grey[100]} height="60" width="60" y="325" x="148" />
    <rect fill={theme.palette.primary.A100} height="20" width="50" y="98" x="90" />
    <rect fill={theme.palette.primary.A100} height="10" width="30" y="88" x="100" />
    <g transform="translate(109)">
      <polygon fill={theme.palette.primary.A100} points="0 88 6 0 12 88" />
      <rect fill={theme.palette.primary.A400} height="3" width="25" y="85" x="-6" />
    </g>
    <g fill={theme.palette.primary.A400}>
      <rect y="355" width="10" x="208" height="30" />
      <rect y="115" width="50" x="90" height="3" />
      <rect y="95" width="30" x="100" height="3" />
    </g>
    <rect fill={theme.palette.primary.A100} height="2" width="60" y="325" x="20" />
    <rect fill={theme.palette.primary.A100} height="2" width="60" y="325" x="148" />
  </SvgIcon>
);

IconBuilding.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconBuilding);



// WEBPACK FOOTER //
// ./src/components/icons/IconBuilding.js